/* eslint-disable import/first */
import './polyfills'

import React from 'react'
import ReactDOM from 'react-dom'
import Root from '@nobia/zeus-components/lib/root'
import settings from '@nobia/zeus-components/lib/settings'
import { PortalProvider } from '@nobia/zeus-components/lib/portal'

import GlobalStyles from './styles/global'
import { App } from './app'

const renderApp = () => {
  ReactDOM.render(
    <Root apiUrl={settings.api} brand={settings.brand} persistSharedState>
      <PortalProvider>
        <GlobalStyles />
        <App />
      </PortalProvider>
    </Root>,
    document.getElementById('root')
  )
}

renderApp()

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./app', renderApp)
}
